// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"4774":"c1383c32","4814":"3070a0f7","8847":"92e7ea31","9097":"4ebacf87"}[chunkId] + ".css";
};